"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Card_styles_1 = require("./Card.styles");
var NewPriceIcon_1 = __importDefault(require("./icons/NewPriceIcon"));
var usePriceDrop_1 = __importDefault(require("../../../hooks/usePriceDrop"));
var formatAndDropDecimal_1 = __importDefault(require("../../../utils/formatAndDropDecimal"));
var Tag_1 = __importDefault(require("../../Tags/Tag"));
var TileDataContext_1 = require("../../TileDataContext");
var PriceDropCard = function () {
    var _a = (0, TileDataContext_1.useTileDataContext)().tileData, total = _a.price.total, previousPrice = _a.previousPrice;
    var _b = (0, usePriceDrop_1.default)(), restrictedState = _b.restrictedState, displayText = _b.displayText;
    if (!previousPrice)
        return null;
    var priceDrop = previousPrice - total;
    return (react_1.default.createElement(Card_styles_1.Card, { "data-qa": "price-drop-card" },
        react_1.default.createElement(Tag_1.default, { text: displayText, tag: "price", bigTag: true }),
        react_1.default.createElement("div", { className: "flex flex-col gap-4" },
            !restrictedState && (react_1.default.createElement(Card_styles_1.Text, null,
                "was",
                ' ',
                react_1.default.createElement("span", { className: "line-through" },
                    "$",
                    (0, formatAndDropDecimal_1.default)(previousPrice)))),
            react_1.default.createElement("div", { className: "flex items-center gap-8" },
                react_1.default.createElement(NewPriceIcon_1.default, null),
                react_1.default.createElement("div", { className: "t-header-m m:t-header-xl text-blue-6" },
                    "$",
                    (0, formatAndDropDecimal_1.default)(total)),
                restrictedState ? (react_1.default.createElement("span", { className: "w-[124px]" })) : (react_1.default.createElement(Card_styles_1.Reduction, null,
                    react_1.default.createElement("span", { className: "t-header-xs text-green-2" },
                        "$",
                        (0, formatAndDropDecimal_1.default)(priceDrop)),
                    "reduction")))),
        react_1.default.createElement(Card_styles_1.Text, null, restrictedState
            ? 'We are always repricing our inventory to make room for new vehicles. Don’t miss out!'
            : "We've lowered our price by $".concat((0, formatAndDropDecimal_1.default)(priceDrop), " to give you more savings."))));
};
exports.default = PriceDropCard;
//# sourceMappingURL=PriceDropCard.js.map